import { gql } from '@apollo/client'
import { workOrderDocumentFragment } from './graphql'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import type { CreateFromWorkOrderItemArgs, WorkOrder } from '@ztechapps/common.contract'

export const createFromWorkOrderItemQuery = gql`
  mutation createFromWorkOrderItem($input: CreateFromWorkOrderItemArgs!) {
    createFromWorkOrderItem(input: $input) {
      ...workOrderDocumentFragment
    }
  }
  ${workOrderDocumentFragment}
`

export const useCreateFromWorkOrderItem = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<WorkOrder, CreateFromWorkOrderItemArgs> => {
  query = query ?? createFromWorkOrderItemQuery

  return useActionMutation({
    query,
    ...props,
  })
}
